/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Last_SessionInputs */

const en_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· this is your last session`)
};

const es_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· esta es tu última sesión`)
};

const de_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· dies ist Ihre letzte Golfstunde`)
};

const zh_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· 这是你的最后一节课`)
};

const ar_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· هذه جلستك الأخيرة`)
};

const fr_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· c'est votre dernière séance`)
};

const vi_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· đây là buổi cuối của bạn`)
};

const sw_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· hiki ni kipindi chako cha mwisho`)
};

const th_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· นี่เป็นเซสชันสุดท้ายของคุณ`)
};

const bs_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· ovo je vaša posljednja sesija`)
};

const ja_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・最後のセッションです`)
};

const ko_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· 마지막 세션입니다`)
};

const pt_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· esta é sua última sessão`)
};

const it_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· questa è la tua ultima sessione`)
};

const sv_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· detta är din sista session`)
};

const nl_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· dit is je laatste sessie`)
};

const da_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· dette er din sidste session`)
};

const nb_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· dette er din siste økt`)
};

const fi_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· tämä on viimeinen tuntisi`)
};

const pl_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· to jest twoja ostatnia sesja`)
};

const ru_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· это ваше последнее занятие`)
};

const tr_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· bu son seansınız`)
};

const hi_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· यह आपका अंतिम सत्र है`)
};

const id_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· ini adalah sesi terakhir Anda`)
};

const ms_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· ini sesi terakhir anda`)
};

const cs_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· toto je vaše poslední lekce`)
};

const el_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· αυτή είναι η τελευταία συνεδρία σας`)
};

const he_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· זהו המפגש האחרון שלכם`)
};

const af_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· dit is jou laaste sessie`)
};

const hu_booking_last_session = /** @type {(inputs: Booking_Last_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· ez az utolsó alkalom`)
};

/**
* | output |
* | --- |
* | "· this is your last session" |
*
* @param {Booking_Last_SessionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_last_session = /** @type {((inputs?: Booking_Last_SessionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Last_SessionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_last_session(inputs)
	if (locale === "de") return de_booking_last_session(inputs)
	if (locale === "zh") return zh_booking_last_session(inputs)
	if (locale === "ar") return ar_booking_last_session(inputs)
	if (locale === "fr") return fr_booking_last_session(inputs)
	if (locale === "vi") return vi_booking_last_session(inputs)
	if (locale === "sw") return sw_booking_last_session(inputs)
	if (locale === "th") return th_booking_last_session(inputs)
	if (locale === "bs") return bs_booking_last_session(inputs)
	if (locale === "ja") return ja_booking_last_session(inputs)
	if (locale === "ko") return ko_booking_last_session(inputs)
	if (locale === "pt") return pt_booking_last_session(inputs)
	if (locale === "it") return it_booking_last_session(inputs)
	if (locale === "sv") return sv_booking_last_session(inputs)
	if (locale === "nl") return nl_booking_last_session(inputs)
	if (locale === "da") return da_booking_last_session(inputs)
	if (locale === "nb") return nb_booking_last_session(inputs)
	if (locale === "fi") return fi_booking_last_session(inputs)
	if (locale === "pl") return pl_booking_last_session(inputs)
	if (locale === "ru") return ru_booking_last_session(inputs)
	if (locale === "tr") return tr_booking_last_session(inputs)
	if (locale === "hi") return hi_booking_last_session(inputs)
	if (locale === "id") return id_booking_last_session(inputs)
	if (locale === "ms") return ms_booking_last_session(inputs)
	if (locale === "cs") return cs_booking_last_session(inputs)
	if (locale === "el") return el_booking_last_session(inputs)
	if (locale === "he") return he_booking_last_session(inputs)
	if (locale === "af") return af_booking_last_session(inputs)
	if (locale === "hu") return hu_booking_last_session(inputs)
	return en_booking_last_session(inputs)
});